import React from 'react'
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import Grid from '@mui/material/Grid';

class Privacy extends React.Component {

    showContactPage = () => {
        this.props.showPopup("contactInfoPopup")
    }

    showDemoPopup = (event) => {
        event.preventDefault()
        this.props.showPopup("demoPopup")
    }

    render() {
        return (
            <div className="mainWrapper">
                <div className="bodyPart">
                    <div className="contentWrapper">
                        <h2 className="pageHead">
                            <LiveHelpIcon />
                            {' '}
                            Help
                            <div className="rightButton">
                                <button className="btn" onClick={this.showContactPage}>Contact Us</button>
                            </div>
                        </h2>
                        <h3 className="subHeadInner">
                            Privacy Policy
                        </h3>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <p>We value your privacy very highly. Please read this Privacy Policy carefully before using the https://www.interactiveedge.com Website (the "Website") operated by Interactive Edge, a(n) Limited Liability Company formed in Delaware, United States ("us," "we," "our") as this Privacy Policy contains important information regarding your privacy and how we may use the information we collect about you.
                                </p>
                                <p>
                                Your access to and use of the Website is conditional upon your acceptance of and compliance with this Privacy Policy. This Privacy Policy applies to everyone, including, but not limited to: visitors, users, and others, who wish to access or use the Website.
                                </p>
                                <p>
                                    By accessing or using the Website, you agree to be bound by this Privacy Policy. If you disagree with any part of the Privacy Policy, then you do not have our permission to access or use the Website.
                                </p>
                                <p>
                                We collect any and all information that you enter on this Website. We collect the following information about you:

                                Category of information	Specific piece of information
                                Identifying information	Name
                                Identifying information	Phone number
                                Identifying information	Email address

                                </p>

                                <h3>How we may use your information</h3>
                                We may use the information that you provide us for the following:
                                <table style={{ padding: "25px" }}>
                                    <tbody>
                                    <tr><th>Category Information</th><th>Specific Piece Of Information</th></tr>
                                    <tr><td>Identifying Information</td><td>Name</td></tr>
                                    <tr><td>Identifying Information</td><td>Phone Number</td></tr>
                                    <tr><td>Identifying Information</td><td>Email Address</td></tr>
                                    </tbody>
                                </table>

                                <h3>How we may use your information</h3>
                                <p>We may use the information that you provide us for the following:</p>

                                 <ul>
                                   <li>Analytics;</li>
                                   <li>Protecting against malicious, deceptive, fraudulent or illegal activity, and prosecuting those responsible for such activities;</li>
                                   <li>Providing customer service;</li>
                                   <li>Verifying customer information.</li>
                                   <li>With whom we share your personal information</li>
                                   <li>We do not share your personal information with any third parties.</li>
                                 </ul>

                                <h3>With whom we share your personal information</h3>
                                <p>We do not share your personal information with any third parties.</p>

                                <h3>Sale of your information</h3>

                                <p>We do not sell your personal information.</p>

                                <h3>Cookies</h3>
                                <p>A cookie is a small piece of data sent from a website and stored on your computer by your web browser. The file is added once you agree to store cookies on your computer or device, and the cookie helps analyze web traffic or lets you know when you visit a particular site. Cookies allow sites to respond to you as an individual. The Website can also tailor its operations to your needs, likes, and dislikes by gathering and remembering information about your preferences.
                                    </p>
                                <p>
                                    This Website collects cookies and may use cookies for reasons including, but not limited to:
                                    </p>
                                <ul>
                                    <li>Analyze our web traffic using an analytics package; </li>
                                    <li>Identify if you are signed in to the Website;</li>
                                    <li>Test content on the Website;</li>
                                    <li>Store information about your preferences;</li>
                                    <li>Recognize when you return to the Website.</li>
                                </ul>
                                <p>Overall, cookies help us provide you with a better Website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.

                                    You can accept or decline cookies. Most web browsers automatically accept cookies, but you can modify your browser setting to decline cookies if you prefer. This setting may prevent you from taking full advantage of the Website.
                                  </p>

                                <h3>Children's privacy</h3>
                                This Website is intended for use by a general audience and does not offer services to children. Should a child whom we know to be under 18 send personal information to us, we will use that information only to respond to that child to inform him or her that they cannot use this Website.

                                <h3>Analytics programs</h3>
                                This Website uses Google Analytics to collect information about you and your behaviors. If you would like to opt out of Google Analytics, please visit https://tools.google.com/dlpage/gaoptout/.

                                <h3>Exercising your rights</h3>
                                may opt out of future sales of personal information by submitting a consumer request to info@interactiveedge.com.
                                Third-party websites
                                This Website may contain hyperlinks to websites operated by parties other than us. We provide such hyperlinks for your reference only. We do not control such websites and are not responsible for their contents or the privacy or other practices of such websites. It is up to you to read and fully understand their Privacy Policies. Our inclusion of hyperlinks to such websites does not imply any endorsement of the material on such websites or any association with their operators.

                                <h3>Do Not Track</h3>
                                Do Not Track is a preference you can set on your browser to inform websites that you do not want to be tracked. We do not support Do Not Track ("DNT"). You can either enable or disable Do Not Track by visiting the Preferences or Settings page of your browser.

                                <h3>Changes to Privacy Policy</h3>
                                We reserve the right to amend this Privacy Policy at any time. We will notify you of any changes to this Privacy Policy by posting the updated privacy policy to this website.

                                <h3>Questions</h3>
If you have any questions about this Privacy Policy, please contact us at info@interactiveedge.com.                 
                                        </Grid>
                        </Grid>
                    </div>
                </div>
            </div>
        )
    }
}

export default Privacy